var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Severity Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4264 14.7792L14.2402 7.41612C13.8962 6.84536 13.3015 6.5 12.6628 6.5C12.0241 6.5 11.4295 6.84536 11.0855 7.41612L6.89929 14.7792C6.59831 15.3114 6.58791 15.9734 6.872 16.5158C7.20055 17.1266 7.81361 17.5026 8.47662 17.4999H16.8491C17.5076 17.5073 18.1196 17.1408 18.4537 16.539C18.7463 15.9906 18.7358 15.3171 18.4264 14.7792ZM12.6628 15.1844C12.3614 15.1844 12.117 14.9253 12.117 14.6056C12.117 14.2859 12.3614 14.0267 12.6628 14.0267C12.9643 14.0267 13.2086 14.2859 13.2086 14.6056C13.2086 14.9253 12.9643 15.1844 12.6628 15.1844ZM12.6628 13.4479C12.9643 13.4479 13.2086 13.1887 13.2086 12.869V10.5535C13.2086 10.2339 12.9643 9.97469 12.6628 9.97469C12.3614 9.97469 12.117 10.2339 12.117 10.5535V12.869C12.117 13.1887 12.3614 13.4479 12.6628 13.4479Z",
    fill: "#F00707"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverity);
export default __webpack_public_path__ + "static/media/severity.ca6883a3fa0ddfadf45f85dec118d77c.svg";
export { ForwardRef as ReactComponent };